import React from "react";

export interface ChargeDetailSectionProps {
  title: string;
  children: React.ReactNode;
}

const ChargeDetailSection = (props: ChargeDetailSectionProps) => {
  const { title, children } = props;

  return (
    <>
      <div className="bg-secondary text-white rounded-top px-4 px-lg-5 py-3">
        <span className="font-weight-bold font-size-lg">{title}</span>
      </div>
      <div className="bg-light rounded-bottom px-4 px-lg-5 pt-4 pb-2 mb-4">{children}</div>
    </>
  );
};

export default ChargeDetailSection;
